<template>
  <section>
    <div class="title">账号信息</div>
    <div class="dt">
      <div class="label">用户ID</div>
      <div class="data">{{user.userPhone}}</div>
    </div>
    <div class="dt">
      <div class="label">昵称</div>
      <div class="data">
        <input class="content" ref="userName" maxlength="20" type="text" v-model="user.userName" readonly="readonly"/>
      </div>
    </div>
    <div class="title marginTop10">个人资料</div>
    <div class="dt">
      <div class="label">性别</div>
      <div class="data">
        <input class="content" ref="sex" maxlength="20" type="text" v-model="user.sex" readonly="readonly"/>
      </div>
    </div>
    <div class="dt">
      <div class="label">生日</div>
      <div class="data">
        <input class="content" ref="birthday" maxlength="20" type="text" v-model="user.birthday" readonly="readonly"/>
      </div>
    </div>
    <div class="dt">
      <div class="label">城市</div>
      <div class="data">
        <input class="content" ref="address" maxlength="20" type="text" v-model="user.address" readonly="readonly"/>
      </div>
    </div>
    <div class="dt">
      <div class="label">个性签名</div>
      <div class="data">
        <input class="content" ref="signName" maxlength="20" type="text" v-model="user.signName" readonly="readonly"/>
      </div>
    </div>
    <div  v-if="role === 'self'">
      <div v-if="set" class="updateBtn" @click="setInfo">修改资料</div>
      <div v-else class="updateBtn" @click="updateInfo">保存</div>
    </div>
    <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
  </section>
</template>

<script>
import * as types from '../../common/js/types'
import loading from '../common/loading.vue'
export default {
  name: 'userHome',
  props: {
    role: {
      type: String,
      default: 'self'
    },
    userId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      user: {
        'userId': '402888c563f7211f0163f721b2d10000',
        'userPhone': '15902059569',
        'passWord': '0A1BAB267B4603F4',
        'accesstoken': '5fda383f-44ca-4e38-9068-69e5b3a8988f',
        'userName': '用户9569',
        'sex': null,
        'birthday': null,
        'address': null,
        'signName': null,
        'articleNum': 18,
        'focusNum': 2,
        'followerNum': 1,
        'score': 124,
        'comeWay': 'WX',
        'headImg': null,
        'createTime': 1528859570000,
        'lastLoginTime': 1532333754000
      },
      msg: '个人中心',
      defaultHeadImg: require('../../assets/image/installer.png'),
      isLoad: true,
      text: '修改资料',
      set: true
    }
  },
  computed: {
  },
  mounted: function (s) {
    let uId = this.userId
    if (this.role === 'self' && this.$root.getUserId()) {
      uId = this.$root.getUserId()
    }
    this.isLoad = true
    let that = this
    that.axios.post('userInfo', {
      userId: uId,
      fromId: this.$root.getUserId()
    }, {
      emulateJSON: true// 需要转json
    }).then(function (response) {
      that.isLoad = false
      if (response.data.status === 0) {
        var res = response.data.value
        that.user = res
        if (that.role === 'self') {
          that.$store.commit(types.LOGIN, res)
        }
      } else {
        that.$store.commit('setToastMsg', response.data.msg)
      }
    }).catch(function (response) {
      that.isLoad = false
      that.$store.commit('setToastMsg', '网络错误')
    })
    this.isLoad = false
  },
  methods: {
    setInfo () {
      this.$refs.userName.removeAttribute('readOnly')
      this.$refs.sex.removeAttribute('readOnly')
      this.$refs.birthday.removeAttribute('readOnly')
      this.$refs.address.removeAttribute('readOnly')
      this.$refs.signName.removeAttribute('readOnly')
      this.set = false
    },
    updateInfo: function () {
      this.isLoad = true
      let that = this
      that.axios.post('/user/updateInfo', {
        userId: that.$root.getUserId(),
        userName: that.user.userName,
        sex: that.user.sex,
        birthday: that.user.birthday,
        address: that.user.address,
        signName: that.user.signName
      }, {
        emulateJSON: true// 需要转json
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          that.$store.commit(types.LOGIN, that.user)
          that.$emit('updateUser')
          that.$store.commit('setToastMsg', '保存成功')
          that.$refs.userName.setAttribute('readOnly', 'true')
          that.$refs.sex.setAttribute('readOnly', 'true')
          that.$refs.birthday.setAttribute('readOnly', 'true')
          that.$refs.address.setAttribute('readOnly', 'true')
          that.$refs.signName.setAttribute('readOnly', 'true')
          that.set = true
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
      that.isLoad = false
    }
  },
  filters: {},
  components: {
    loading
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  padding-left: 30px;
  background-color: #FFFFFF;
  height: 50px;
  line-height: 50px;
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
  font-family: "SourceHanSansCN-Normal";
}
.dt {
  padding-left: 30px;
  background-color: #FFFFFF;
  line-height: 50px;
  width: 920px;
}
.marginTop10 {
  margin-top: 10px;
}
.dt:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden
}
.dt .label {
  float: left;
  width: 150px;
  font-size: 16px;
  color: #888;
  font-family: "SourceHanSansCN-Normal";
}
.dt .data {
  float: left;
  padding-right: 30px;
  font-size: 16px;
  color: #333;
  font-family: "SourceHanSansCN-Normal";
}
.dt .data input {
  width: 700px;
  /*border: 1px solid #F0F0F0;*/
  font-size: 16px;
  line-height: 30px;
  font-family: "SourceHanSansCN-Normal";
}
.updateBtn {
  margin: 20px 0;
  color: #fff;
  background-color: #05b570;
  font-size: 16px;
  line-height: 42px;
  border-radius: 2px;
  cursor: pointer;
  border: 1px solid transparent;
  width: 190px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/user/userInfo.vue